import { useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { useQueryCustomerEntity } from "../../../../query/onboarding/queries/useQueryCustomerEntity";
import {
  FormAdditionalInfoRepresentative,
  FormDataAdditionalInfoRepresentative
} from "./FormAdditionalInfoRepresentative";
import { Review } from "./Review";

type Props = {
  basePath: string;
  onNext?: () => void;
};

export const MissingData: React.FC<Props> = props => {
  const history = useHistory();

  const queryCustomerEntity = useQueryCustomerEntity();

  const [formData, setFormData] = useState<
    FormDataAdditionalInfoRepresentative | undefined
  >();

  return (
    <Switch>
      <Route
        path={`${props.basePath}/data`}
        render={() => (
          <FormAdditionalInfoRepresentative
            defaultValues={formData}
            onSubmit={data => {
              setFormData(data);
              history.push(`${props.basePath}/review`);
            }}
            country={queryCustomerEntity.data?.country ?? "US"}
          />
        )}
      />

      <Route
        path={`${props.basePath}/review`}
        render={() => (
          <Review
            formData={formData}
            onBack={() => {
              history.push(`${props.basePath}/data`);
            }}
            country={queryCustomerEntity.data?.country ?? "US"}
          />
        )}
      />

      <Redirect from={props.basePath} to={`${props.basePath}/data`} />
    </Switch>
  );
};
